module.exports = __webpack_public_path__ + "img/user5-128x128.b628ca59.jpg";